'use client'

import type { AnchorHTMLAttributes } from 'react'
import { usePlausible } from 'next-plausible'
import {
  BRACKET_EXAMPLE_EVENT,
  type BracketExampleId,
} from '../bracket-maker/examples'
import { buttonVariants } from '../ui/button'
import { cn } from '@/lib/utils'
import { ArrowUpRight } from 'lucide-react'
import { Link } from '@/i18n/navigation'
import type { Locale } from '@/i18n/routing'

export function TrackedBracketToolLink({
  locale,
  teamCount,
  ...props
}: {
  locale: Locale
  teamCount: number
  href: string
  children: React.ReactNode
  className?: string
}) {
  const plausible = usePlausible()
  return (
    <Link
      {...props}
      locale={locale === 'en' ? undefined : locale}
      onClick={() => {
        try {
          plausible('BracketTemplateOpen', {
            props: {
              locale,
              team_count: teamCount,
              placement: 'home_templates',
            },
          })
        } catch {}
      }}
    />
  )
}

// 埋点失败不能阻止浏览器下载文件、打开打印页或使用编辑器。
export function TrackedTemplateLink({
  event,
  locale,
  teamCount = 8,
  template = 'blank',
  format,
  ...props
}: AnchorHTMLAttributes<HTMLAnchorElement> & {
  event: 'BracketTemplateDownload' | 'BracketTemplatePrint'
  locale: string
  teamCount?: number
  template?: 'blank' | 'seeded'
  format?: 'png' | 'svg' | 'print'
}) {
  const plausible = usePlausible()
  return (
    <a
      {...props}
      onClick={() => {
        try {
          plausible(event, {
            props: {
              locale,
              team_count: teamCount,
              template,
              ...(format ? { format } : {}),
            },
          })
        } catch {}
      }}
    />
  )
}

export function BracketExampleButton({
  example,
  children,
  className,
}: {
  example: BracketExampleId
  children: React.ReactNode
  className?: string
}) {
  return (
    <button
      type="button"
      className={cn(
        buttonVariants({ variant: 'outline' }),
        'h-auto min-h-11 gap-2 whitespace-normal py-3',
        className,
      )}
      onClick={() => {
        window.dispatchEvent(
          new CustomEvent(BRACKET_EXAMPLE_EVENT, { detail: example }),
        )
      }}
    >
      {children}
      <ArrowUpRight className="h-4 w-4 shrink-0" />
    </button>
  )
}
